var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { row: !_vm.short } }, [
    _c(
      "div",
      {
        staticClass: "availabilityOutter",
        class: {
          "col-12 align-items-center": !_vm.short,
          liveShippingInfo: _vm.short,
          isChristmas: _vm.currentDayOfYear > 330 && _vm.currentDayOfYear < 359,
        },
      },
      [
        _c("span", {
          staticClass: "availabilityText",
          domProps: { innerHTML: _vm._s(_vm.avDisplayHoliday) },
        }),
      ]
    ),
    _vm._v(" "),
    !_vm.short
      ? _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: {
              id: "freightInfo",
              tabindex: "-1",
              role: "dialog",
              "aria-labelledby": "freightInfoToggle",
              "aria-hidden": "true",
            },
          },
          [_vm._m(0)]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "modal-dialog", attrs: { role: "document" } },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body d-flex flex-column" }, [
            _c("h3", { staticClass: "mb-2" }, [
              _vm._v("Lieferung per Spedition"),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "Das Produkt ist auf Lager und wird umgehend für den Versand vorbereitet. \n                        Die Spedition wird sich in den nächsten Tagen mit Ihnen in Verbindung setzen,\n                        um einen Liefertermin zu vereinbaren."
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-bkm btn-sm ml-auto mt-2",
                attrs: { type: "button", "data-dismiss": "modal" },
              },
              [_vm._v("Schließen")]
            ),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }